import React from 'react';
import { useTranslation } from "react-i18next";

import { ReactComponent as InfoIcon } from 'assets/icons/ico_info_circle_blue.svg';
import AirPassItem from './airPassItem';

const AirPassTable = ({ airPasses, setAirPass }) => {
    const { t } = useTranslation();

    if (!airPasses) {
        return (null);
    }

    return (
        <>
            <div className="-mr-6 -ml-6 airpark-scroll overflow-x-scroll">
                <table className="table-auto w-full">
                    <thead className=''>
                        <tr className="text-left bg-airpark-gray-300 h-11">
                            <th className="pl-6 whitespace-nowrap">{t('airPassTable.id')}</th>
                            <th className="pl-6 whitespace-nowrap">{t('airPassTable.description')}</th>
                            <th className="pl-6 whitespace-nowrap">{t('airPassTable.location')}</th>
                            <th className="pl-6 whitespace-nowrap">{t('airPassTable.floor')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {airPasses?.length > 0 && airPasses.map((airPass, i) => {
                            return (<AirPassItem 
                                        key={i} 
                                        airPass={airPass} 
                                        airPasses={airPasses} 
                                        setAirPass={setAirPass} />)
                        })}
                        {airPasses?.length < 1 &&
                            <tr className="h-16">
                                <td className="text-center" colSpan={4}>
                                    <div className="flex pl-6 gap-3 flex-row items-center justify-left">
                                        <InfoIcon className="h-6 w-6" />
                                        <span>{t('airPassTable.noAirPassesFound')}</span>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default AirPassTable;